import React, { useEffect, useRef } from 'react'
import { Heading, Text } from '@/components/lib'
import useStore from '../../store'
import useTitle from '../../hooks/useTitle'

export default function TrialBooking () {
  const { trial } = useStore()
  useTitle('Booking', trial)

  return (
    <>
      <Heading as='h2' size='lg'>Booking form</Heading>
      <Text>Use our SimplyBook integration to setup a meeting. Please note that previously-arranged meetings are not currently available on this page.</Text>
      <BookingWidget />
    </>
  )
}

function BookingWidget () {
  const widgetContainerRef = useRef(null)

  useEffect(() => {
    const script = document.createElement('script')
    script.async = true
    script.src = '//widget.simplybook.it/v2/widget/widget.js'
    script.onload = () => {
      // eslint-disable-next-line
      new window.SimplybookWidget({ widget_type: 'iframe', url: 'https://trialflare.simplybook.it', theme: 'bookingtroll', theme_settings: { timeline_hide_unavailable: '1', hide_past_days: '0', timeline_show_end_time: '0', timeline_modern_display: 'as_slots', sb_base_color: '#1f3f68', display_item_mode: 'block', body_bg_color: '#ffffff', sb_review_image: '', dark_font_color: '#0f1926', light_font_color: '#ffffff', btn_color_1: '#385e8e', sb_company_label_color: '#19375e', hide_img_mode: '1', sb_busy: '#c7b3b3', sb_available: '#e5f2ff' }, timeline: 'modern', datepicker: 'top_calendar', is_rtl: false, app_config: { clear_session: 0, allow_switch_to_ada: 0, predefined: [] }, container_id: 'sbw_9zli29' })
    }
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  return (
    <div id='sbw_9zli29' ref={widgetContainerRef} />
  )
}
